<template>
  <div class="D2Form">
    <header class="D2Form-header">
      <img :src="ref.icon" alt="">
      <h1>{{ ref.title }}</h1>
    </header>
    <main class="D2Form-body">
      <div class="D2Form-body-content" id="content">
        <Pages ref="pages">
          <Page :category="1">
            <h2 class="D2Form-body-title">Dados da proposta</h2>
            <div class="D2Form-input">
              <Icon type="ios-person-outline"></Icon>
              <Input readonly :value="response.lead.name" placeholder="Digite o seu nome"></Input>
            </div>
            <div class="D2Form-input">
              <Icon type="ios-email-outline"></Icon>
              <Input readonly :value="response.lead.email" placeholder="Digite o seu email"></Input>
            </div>
            <div class="D2Form-input">
              <Icon type="ios-telephone-outline"></Icon>
              <Input readonly :value="response.lead.phone" placeholder="Digite um telefone para contato"></Input>
            </div>

            <div class="D2Form-input" style="pointer-events: none">
              <i-switch :value="response.lead.newsletter === 1" size="small"></i-switch>
              <span style="color: rgb(187, 190, 196);margin-left:.5em;">
                Desejo receber informações, promoções e novidades da D2 <small style="opacity: .7;">não gostamos de spam ;)</small>
              </span>
            </div>

            <dl class="List" style="text-align: left;">
              <dt class="D2Form-body-title D2Form-body-title--h3">Tem site?</dt>
              <dd>{{ response.has_site === 0 ? 'Não' : `${response.site_name} - ${response.site_link}` }}</dd>

              <dt class="D2Form-body-title D2Form-body-title--h3">Estilo de site?</dt>
              <dd>{{ response.site_style }}</dd>

              <dt class="D2Form-body-title D2Form-body-title--h3">Descrição?</dt>
              <dd>{{ response.description }}</dd>

              <dt class="D2Form-body-title D2Form-body-title--h3">Prazo?</dt>
              <dd>{{ response.deadline === null ? "Flexível" : response.deadline }}</dd>

              <dt class="D2Form-body-title D2Form-body-title--h3">Segmento?</dt>
              <dd>{{ response.segment }}</dd>
            </dl>

            <section class="D2Form-section">
              <h2 class="D2Form-body-title">Referências</h2>

                <Table no-data-text="Sem referências cadastradas" :columns="[
                  {
                      title: 'Name',
                      key: 'name'
                  },
                  {
                      title: 'Site',
                      key: 'site'
                  },
                  {
                      title: 'Obs',
                      key: 'obs'
                  }]" :data="referencias">
                </Table>

            </section>

            <section class="D2Form-section" scope="proposito">
              <h2 class="D2Form-body-title">Qual o propósito deste projeto?</h2>

              <Choices class="Choices--small Choices--locked" type="checkbox">
                  <Choice v-for="proposito in response.propositos" :key="proposito.id" :label="proposito.id" :img="proposito.icon" :title="proposito.name"></Choice>
              </Choices>
            </section>

            <section class="D2Form-section" scope="funcionalidade">
              <h2 class="D2Form-body-title">Funcionalidades</h2>

              <Choices class="Choices--small Choices--locked" type="checkbox">
                  <Choice v-for="funcionalidade in response.funcionalidades" :key="funcionalidade.id" :label="funcionalidade.id" :img="funcionalidade.icon" :title="funcionalidade.name"></Choice>
              </Choices>
            </section>

            <section class="D2Form-section">
              <h2 class="D2Form-body-title">Audiência</h2>

              <Choices class="Choices--small Choices--locked" type="checkbox">
                  <Choice v-show="audiencia.indexOf('Crianças') !== -1" label="Crianças" img="assets/i-criancas.png" title="Crianças"></Choice>
                  <Choice v-show="audiencia.indexOf('Adolescentes') !== -1" label="Adolescentes" img="assets/i-adolescentes.png" title="Adolescentes"></Choice>
                  <Choice v-show="audiencia.indexOf('Jovens ') !== -1" label="Jovens Adultos" img="assets/i-jovens-adultos.png" title="Jovens Adultos"></Choice>
                  <Choice v-show="audiencia.indexOf('Adultos') !== -1" label="Adultos" img="assets/i-adultos.png" title="Adultos"></Choice>
                  <Choice v-show="audiencia.indexOf('Idosos') !== -1" label="Idosos" img="assets/i-idosos.png" title="Idosos"></Choice>
              </Choices>
            </section>

            <section class="D2Form-section" scope="calltoaction">
              <h2 class="D2Form-body-title">O que você espera que o seu público faça no site</h2>

              <Choices class="Choices--small Choices--locked" type="checkbox">
                  <Choice v-for="calltoaction in response.calltoactions" :key="calltoaction.id" :label="calltoaction.id" :img="calltoaction.icon" :title="calltoaction.name"></Choice>
              </Choices>
            </section>

          </Page>
        </Pages>
      </div>
    </main>
  </div>
</template>

<script>
import last from 'lodash-es/last'
import filter from 'lodash-es/filter'

import Page from '@/components/Page.vue'
import Pages from '@/components/Pages.vue'
import Choice from '@/components/Choice.vue'
import Choices from '@/components/Choices.vue'

export default {
  data () {
    return {
      ref: {},
      response: {
        lead: {}
      },
    }
  },

  components: {
    Page, Pages, Choices, Choice
  },

  computed: {
    referencias () {
      const refs = this.response.referencias
      return refs
    },
    audiencia () {
      const audience = this.response.audience || '[]'
      return JSON.parse(audience)
    },
    refs () {
      return [
        {slug: 'site-completo-wordpress', title: 'SITE COMPLETO - WORDPRESS', icon: 'assets/header-icon.png'},
        {slug: 'site-estatico', title: 'SITE ESTÁTICO', icon: 'assets/header-icon.png'},
        {slug: 'criacao-de-layout', title: 'CRIAÇÃO DE LAYOUT', icon: 'assets/header-icon.png'},
      ]
    }
  },

  mounted () {
    const vm = this

    this.$store.commit('ui/init')

    function sameHeightCards(cards) {

      cards.forEach(cardEl => {
          const scope = document.querySelectorAll(cardEl)
          const heights = []
          scope.forEach(card => card.style.height = 'auto')
          scope.forEach(card => heights.push(card.offsetHeight))
          heights.sort()
          const maxHeight = last(heights)

          if (maxHeight > 0) scope.forEach(card => card.style.height = `${maxHeight}px`)
      })
    }

    this.$axios.get(`responses/${this.$route.params.id}?token=${this.$route.query.token}`, {})
      .then(function (response) {
        vm.response = response.data[0]

        const ref = filter(vm.refs, ref => ref.slug == vm.response.ref)[0]
        vm.ref = ref ? ref : vm.refs[0]

        vm.$nextTick(function () {
          sameHeightCards([
            '[scope="audiencia"] .Choice-Card',
            '[scope="proposito"] .Choice-Card',
            '[scope="personalidade"] .Choice-Card',
            '[scope="funcionalidade"] .Choice-Card',
            '[scope="calltoaction"] .Choice-Card'
          ])
        })


      })
      .catch(function (error) {
        // window.location.href = '/'
      })

      vm.$nextTick(function () {
        sameHeightCards([
          '[scope="audiencia"] .Choice-Card',
          '[scope="proposito"] .Choice-Card',
          '[scope="personalidade"] .Choice-Card',
          '[scope="funcionalidade"] .Choice-Card',
          '[scope="calltoaction"] .Choice-Card'
        ])
      })

      window.onresize = function () {
        sameHeightCards([
          '[scope="audiencia"] .Choice-Card',
          '[scope="proposito"] .Choice-Card',
          '[scope="personalidade"] .Choice-Card',
          '[scope="funcionalidade"] .Choice-Card',
          '[scope="calltoaction"] .Choice-Card'
        ])
      }
  }
}
</script>